import { GettingStartedStoreAccess } from "../../libs/store";
import { SubscriptionBlockStep } from "../../libs/GettingStartedChecklist/SubscriptionBlockStep";
import { SubscriptionWidgetButton } from "./SubscriptionWidgetButton";
import SetupStep from "../SetupStep";
import { LegacyStack, Spinner, Text } from "@shopify/polaris";
import { VerifyImplementationButton } from "./VerifyImplementationButton";
import { ThemeSelect } from "./ThemeSelect";
import { VerifyImplementationText } from "./VerifyImplementationText";
import { MarkStepAsCompleteButton } from "./MarkStepAsCompleteButton";

export const SubscriptionBlock = () => {
  const setup = GettingStartedStoreAccess.useSetup();
  const displayVerificationText = GettingStartedStoreAccess.useDisplayVerifyImplementationText();
  const checklist = GettingStartedStoreAccess.useChecklist();

  if (!checklist) {
    return <Spinner />;
  }

  return (
    <SetupStep
      title="Add Subscription App Block"
      description="Add the Smartrr block to your product pages for subscription options to appear."
      isStepCompleted={!!setup?.onSiteSetup.smartrrWidget?.completed}
      id="install-subscription-app-block"
      statusBadgeTestId="add-app-block-status-badge"
      isOpen={checklist.isOpen(SubscriptionBlockStep)}
    >
      <LegacyStack vertical>
        <LegacyStack alignment="center">
          <Text as="span" variant="bodyMd">
            To enable subscriptions on your products, you&apos;ll need to add the Smartrr app block to your
            product page templates in the Shopify Theme editor.
          </Text>
          <LegacyStack.Item fill>
            <ThemeSelect />
          </LegacyStack.Item>
        </LegacyStack>
        <LegacyStack alignment="center">
          <SubscriptionWidgetButton />
          <VerifyImplementationButton />
        </LegacyStack>
        {displayVerificationText ? <VerifyImplementationText /> : null}
        <MarkStepAsCompleteButton isDisabled={checklist?.isComplete(SubscriptionBlockStep)} />
      </LegacyStack>
    </SetupStep>
  );
};
